var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thumbnail"},[_c('div',{staticClass:"image"},[(_vm.imageUrl)?_c('img',{attrs:{"src":_vm.imageUrl,"alt":"imageurl"}}):_vm._e()]),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }